import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ProjectInterestsPage from "@/pages/admin/ProjectInterestsPage";

export const Route = createFileRoute("/_admin/admin/project-interests")({
  head: () => pageHead("Admin · Project Interests", "AKIVA admin · project interests portal.", "/admin/project-interests", true),
  component: ProjectInterestsPage,
});
